<template>
  <a class="car-card" :href="getHrefForDetail(car)"
    :class="{'car-card--mobile': deviceType === 'mobile'}">
    <!-- 图片和 Logo 区域 -->
    <div class="car-card__img-wrapper">
      <img :src="car.image" class="car-card__img" :alt="car.model">
      <div class="car-card__card-logo-box">
        <img :src="car.logo" class="car-card__card-logo">
      </div>
      <!-- 评分标签 (如果有) -->
      <div v-if="car.rate" class="car-card__rating">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
          fill="#fff">
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
        <span>{{ car.rate }}</span>
      </div>

      <div v-else class="car-card__release-badge">
        <img src="@/assets/calendar.svg" alt="">
        <span>{{ car.marketTime }}</span>
      </div>
    </div>

    <!-- 文字内容 -->
    <div class="car-card__content">
      <div class="car-card__header">
        <h3 class="car-card__title">{{ car.model }}</h3>
        <p class="car-card__brand-name">{{ car.brand }}</p>
      </div>

      <!-- 信息网格 -->
      <div class="car-card__info-grid">
        <div class="car-card__info-item">
          <img src="@/assets/calendar.svg" alt="year">
          <span>{{ car.marketTime.replace('-', '.') }}</span>
        </div>
        <div class="car-card__info-item">
          <img src="@/assets/body-type.svg" alt="purpose">
          <span>{{ car.purpose }}</span>
        </div>
        <div class="car-card__info-item">
          <img src="@/assets/car-type.svg" alt="type">
          <span>{{ car.type }}</span>
        </div>
        <div class="car-card__info-item">
          <img src="@/assets/homehero/Budget.svg" alt="purpose">
          <span>{{ formattedPrice }}</span>
        </div>
      </div>

      <!-- 底部价格和箭头 -->
      <!-- <div class="car-card__footer">
        <span class="car-card__price">{{ car.priceDisplay || car.price }}</span>
        <div class="car-card__arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="white" />
          </svg>
        </div>
      </div> -->
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarCard',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['deviceType']),
    formattedPrice () {
      const item = this.car;

      // 优先使用 leastPrice 和 mostPrice 字段格式化价格
      if (item.leastPrice || item.mostPrice) {
        return this.formatPriceRange(item.leastPrice, item.mostPrice);
      }

      // 如果没有 leastPrice 和 mostPrice，但有 price 字段，尝试从 price 字段提取价格
      if (item.price && typeof item.price === 'string') {
        const mostPriceMatch = item.price.match(/most\s+price\s+\{\$([\d,]+)\}/);
        const leastPriceMatch = item.price.match(/least\s+price\s+\{\$([\d,]+)\}/);

        let extractedMostPrice = null;
        let extractedLeastPrice = null;

        if (mostPriceMatch && mostPriceMatch[1]) {
          extractedMostPrice = parseInt(mostPriceMatch[1].replace(/,/g, ''), 10);
        }

        if (leastPriceMatch && leastPriceMatch[1]) {
          extractedLeastPrice = parseInt(leastPriceMatch[1].replace(/,/g, ''), 10);
        }

        if (extractedLeastPrice || extractedMostPrice) {
          return this.formatPriceRange(extractedLeastPrice, extractedMostPrice);
        }

        return item.price;
      }

      return 'Price upon request';
    }
  },
  methods: {
    formatPriceRange (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        return `${formatNumber(leastPrice)} - ${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        return `<${formatNumber(mostPrice)}`;
      }
      return null;
    },
    getHrefForDetail (car) {
      const channel = this.$route.params.channel;
      const name = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      return channel ? `/${channel}/cars/${name}/${car.id}` : `/cars/${name}/${car.id}`;
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.car-card {
	background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
	border-radius: rem(16);
	border: 1px solid rgba(255, 255, 255, 0.1);
	display: flex;
	flex-direction: column;
	text-decoration: none;
	transition: all 0.3s ease;
	overflow: hidden;
	box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

	&:hover {
		transform: translateY(-5px);
		border-color: rgba(226, 55, 45, 0.5);
	}

	&__img-wrapper {
		position: relative;
		height: rem(200);
		padding: rem(8);
	}

	&__img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(12);
	}

	&__logo-circle {
		position: absolute;
		top: rem(8);
		left: rem(8);
		width: rem(36);
		height: rem(36);
		background: #fff;
		border-radius: rem(12) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.32);
	}

	&__logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__card-logo-box {
		position: absolute;
		top: rem(8);
		left: rem(8);
		width: rem(32);
		height: rem(32);
		background: #fff;
		border-radius: rem(12) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
	}

	&__card-logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__release-badge {
		position: absolute;
		top: rem(8);
		left: rem(40);
		background: #e2372d;
		border-radius: 0 0 rem(12) 0;
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		gap: rem(4);
		img {
			width: rem(12);
			height: rem(12);
			filter: brightness(0) invert(1);
		}
		span {
			color: #fff;
			font-size: rem(12);
		}
	}

	&__rating {
		position: absolute;
		top: rem(8);
		left: rem(40);
		background: #e2372d;
		padding: rem(4) rem(8);
		border-radius: 0 0 rem(12) 0;
		display: flex;
		align-items: center;
		gap: rem(4);
		span {
			color: #fff;
			font-size: rem(12);
			font-weight: 700;
		}
	}

	&__content {
		padding: rem(16) rem(20) rem(20);
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__header {
		display: flex;
		justify-content: space-between;
		gap: rem(20);
	}

	&__title {
		font-weight: 800;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		overflow: hidden;
		color: #fff;
		text-overflow: ellipsis;
		font-family: Inter;
		font-size: rem(16);
		font-style: normal;
		font-weight: 800;
		line-height: rem(16); /* 100% */
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1; /* 占据剩余空间，允许收缩 */
		min-width: 0; /* 防止 flex-shrink 失效 */
	}

	&__brand-name {
		font-size: rem(12);
		color: rgba(255, 255, 255, 0.5);
		overflow: hidden;
		color: #fff;
		text-overflow: ellipsis;
		font-family: Inter;
		font-style: normal;
		font-weight: 200;
		line-height: rem(12); /* 100% */
		margin: 0;
		flex-shrink: 0; /* 禁止收缩，确保品牌始终完整显示 */
		white-space: nowrap; /* 防止品牌换行 */
	}

	&__info-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: rem(8);
		margin-top: rem(12);
	}

	&__info-item {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(10) rem(12);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: rem(8);
		min-width: 0; // 确保省略号生效的关键

		img {
			width: rem(24);
			height: rem(24);
			flex-shrink: 0;
		}

		span {
			color: #ffffff;
			font-size: rem(12);
			font-weight: 600;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			width: 100%;
			text-align: center;
		}
	}

	&__footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: rem(12);
	}

	&__price {
		color: #e2372d;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
	}

	&__arrow {
		display: flex;
	}

	&--mobile {
		width: 100%;
		&__img-wrapper {
			height: rem(180);
		}
		&__info-grid {
			grid-template-columns: 1fr 1fr;
		}
	}
}
</style>